import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Footer from './components/Footer';
import Header from './components/Header';
import Sidebar from './restaurant/Sidebar';
import HomeScreen from './screens/HomeScreen';

import UserHome from './user/UserHome';
import UserWallet from './user/UserWallet';
import UserMarket from './user/UserMarket';
import UserTrades from './user/UserTrades';
import UserNotifications from './user/UserNotifications';
import UserAccount from './user/UserAccount';

import Restaurant from './restaurant/Restaurant';
import RestaurantMenu from './restaurant/RestaurantMenu';
import RestaurantOrder from './restaurant/RestaurantOrder';
import RestaurantMarketPlace from './restaurant/RestaurantMarketPlace';
import RestaurantAnalytics from './restaurant/RestaurantAnalytics';
import RestaurantWallet from './restaurant/RestaurantWallet';
import RestaurantTrades from './restaurant/RestaurantTrades';
import RestaurantNotifications from './restaurant/RestaurantNotifications';
import RestaurantSettings from './restaurant/RestaurantSettings';
import RestaurantContact from './restaurant/RestaurantContact';
import RestaurantProfile from './restaurant/RestaurantProfile';

function App() {
  
  return (
    <BrowserRouter>
      <Header />
      <Flex as='main' mt='72px' direction='row' bgColor='white.900'>
        <Box flex='1' p='6' overflow='auto'>
          
          <Routes>
            {/* Non-dashboard routes */}
            <Route path='/' element={<HomeScreen />} />

            { /* User Routes */}
            <Route path='/user-home' element={<UserHome />} />
            <Route path='/user-wallet' element={<UserWallet />} />
            <Route path='/user-market' element={<UserMarket />} />
            <Route path='/user-trades' element={<UserTrades />} />
            <Route path='/user-notifications' element={<UserNotifications />} />
            <Route path='/user-account' element={<UserAccount />} />

            {/* Restaurant dashboard routes */}
            <Route
              path='/*'
              element={
                <RestaurantRoutes                  
                />
              }
            />
          </Routes>
        </Box>
      </Flex>
      <Footer />
    </BrowserRouter>
  );

  // Nested component for restaurant dashboard routes
  function RestaurantRoutes() {
    return (
      <Flex direction='row' flex='1'>
        
        <Box w={{ base: '0', md: '250px' }} display={{ base: 'none', md: 'block' }}>
          <Sidebar />
        </Box>
        <Box flex='1' p='6'>
          <Routes>
            <Route path='/restaurant' element={<Restaurant />} />
            <Route path='/restaurant-menu' element={<RestaurantMenu />} />
            <Route path='/restaurant-orders' element={<RestaurantOrder />} />
            <Route path='/restaurant-market-place' element={<RestaurantMarketPlace />} />
            <Route path='/restaurant-analytics' element={<RestaurantAnalytics />} />
            <Route path='/restaurant-wallet' element={<RestaurantWallet />} />
            <Route path='/restaurant-trades' element={<RestaurantTrades />} />
            <Route path='/restaurant-notifications' element={<RestaurantNotifications />} />
            <Route path='/restaurant-settings' element={<RestaurantSettings />} />
            <Route path='/restaurant-contact' element={<RestaurantContact />} />
            <Route path='/restaurant-profile' element={<RestaurantProfile />} />
          </Routes>
        </Box>
      </Flex>
    );
  }
}

export default App;